<template>
    <div class="msg">
        <div class="user-mes-box">
            <div class="dialog-content" v-text="lan['K160_NoSupport']"></div>
            <div class="user-mes-btns cle">
                <button type="button" @click="confirm" :title="lan['K162_Down']" v-text="lan['K162_Down']"></button>
                <button type="button" @click="cancle" :title="lan['K018_Cancel']" style="margin-left:20px;" v-text="lan['K018_Cancel']"></button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'Vpload',
    props:['lan'],
    data(){
        return{
            
        }
    },
    methods:{
        confirm:function(){
            window.open(this.baseData['Plug-in']);
            this.$emit('close');
        },
        cancle:function(){
            this.$emit('close');
        },
        close:function(){
            this.$emit('close');
        }
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
    }
    .user-mes-box{
        width:440px;
        margin: 0 auto;
        margin-top:30px;
        padding: 20px;
    }
    .dialog-content{
        width:100%;
    }
    .user-mes-btns{
        width:100%;
        height:30px;
        margin-top:20px;
        text-align: right;
    }
    .user-mes-btns button{
        width:80px;
        height:100%;
        color:#fff;
        background-color: #1A73E8;
        box-sizing: border-box;
        border:none;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

</style>


// WEBPACK FOOTER //
// src/components/Vpload.vue